<template>
  <app-section-wrap :modifier="'login'">
    <div column="+1 10 +1">
      <div class="split-card">
        <div class="card-left">
          <h1 class="_text-center _mbs">
          Forgot Password?
        </h1>
        <cloud-cannon-content
          class="_p0"
          v-if="!submitted"
          :content-loading="cloudCannonContentLoading"
          :content="cloudCannonContent.header"
        />
        <p
          v-if="resetPasswordMessage && submitted"
          class="_mt0 _text-center leaf"
          role="status"
        >
          {{resetPasswordMessage}}
        </p>

        <form v-if="!submitted" ref="form" @submit.prevent="sendResetPasswordInstructions">
          <app-input
            v-model="$v.userId.$model"
            value-key="user-name"
            :required="true"
            :error-message="userIdError"
            :invalid="$v.userId.$invalid"
            label="User ID:"
            modifier=""
          />

          <p
            v-if="resetPasswordMessage"
            class="_mt0 _text-center lips"
            role="status"
          >
            {{resetPasswordMessage}}
          </p>
          <async-button
            :disabled="disable"
            type="submit"
            class="_mtxs --sm"
            :executing="issuingResetPasswordInstructions"
          >
            <template #buttonContent>
              <span>Send Reset Password Email</span>
            </template>
          </async-button>
        </form>
        <router-link id="back-to-login" to="/">Back to Sign In screen</router-link>
      </div>
        <div class="card-divider"></div>
        <div class="card-right">
          
        </div>
      </div>
      <cloud-cannon-content
          class="_mtm _mb0 _p0"
          :content-loading="cloudCannonContentLoading"
          :content="cloudCannonContent.footer"
        />
    </div>
  </app-section-wrap>
</template>

<script>
  import AppSectionWrap from '@molecules/SectionWrap.vue'
  import AsyncButton from '@/components/molecules/AsyncButton.vue'
  import { REQUEST_RESET_PASSWORD_INSTRUCTIONS } from '@store/modules/auth/actionTypes'
  import { mapState } from 'vuex'
  import fetchable from '@mixins/fetchable'
  import CloudCannonable from '@mixins/CloudCannonable'
  import AppInput from '@atoms/Input'
  import { required } from 'vuelidate/lib/validators'

  export default {
    mixins: [fetchable, CloudCannonable],
    components: {
      AppSectionWrap,
      AsyncButton,
      AppInput
    },
    validations: {
      userId: {
        required
      }
    },
    data () {
      return {
        userId: '',
        submitted: false,
        error: false,
        fetchers: [
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/forgot-password.json'
            },
            config: {
              root: true
            }
          }
        ]
      }
    },
    computed: {
      disable () {
        return this.$v.$invalid
      },
      userIdError () {
        return this.$v.userId.required ? '' : 'required'
      },
      ...mapState({
        issuingResetPasswordInstructions: state => state.auth.issuingResetPasswordInstructions,
        resetPasswordMessage: state => state.auth.resetPasswordMessage
      }),
      formObject () {
        return {
          userId: this.userId
        }
      }
    },
    methods: {
      sendResetPasswordInstructions () {
        this.$store.dispatch(REQUEST_RESET_PASSWORD_INSTRUCTIONS, this.userId)
          .then(submitted => {
            this.submitted = submitted
          })
      }
    }
  }
</script>
